import { render, staticRenderFns } from "./AdminCrawl.vue?vue&type=template&id=04112ae7&scoped=true"
import script from "./AdminCrawl.vue?vue&type=script&lang=js"
export * from "./AdminCrawl.vue?vue&type=script&lang=js"
import style0 from "./AdminCrawl.vue?vue&type=style&index=0&id=04112ae7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04112ae7",
  null
  
)

export default component.exports